import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { btnPrimary, inputCls, labelCls, overline } from "@/components/kit";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Administration" path="/admin/login" />
      <div className="flex min-h-screen items-center justify-center bg-mist px-5">
        <div className="w-full max-w-md">
          <div className="flex items-center justify-center">
            <Logo size="lg" />
          </div>
          <div className="mt-10 rounded-2xl border border-ink/10 bg-white p-8 shadow-sm md:p-10">
            <span className={overline}>Espace privé</span>
            <h1 className="mt-3 font-serif text-4xl font-medium text-ink">Connexion</h1>
            <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
              <div>
                <label className={labelCls}>Email</label>
                <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="admin@desir-events.com" />
              </div>
              <div>
                <label className={labelCls}>Mot de passe</label>
                <input type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="••••••••" />
              </div>
              {error && <p className="text-sm text-red-500" data-testid="login-error">{error}</p>}
              <button type="submit" disabled={loading} className={`${btnPrimary} w-full disabled:opacity-60`} data-testid="login-submit">
                {loading ? "Connexion…" : "Se connecter"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
